// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g
			stroke="none"
			strokeWidth="1"
			fillRule="evenodd"
			transform="translate(0.000000, 3.000000)"
		>
			<path d="M1.61777778,5.84888889 C1.03111111,4.28444444 1.12,2.54222222 1.86666667,
				1.04888889 C1.99111111,0.782222222 1.86666667,0.462222222 1.6,0.337777778
				C1.35111111,0.213333333 1.04888889,0.32 0.906666667,0.568888889 C0.0177777778,
				2.32888889 -0.0888888889,4.37333333 0.604444444,6.22222222 C0.711111111,6.50666667
				1.01333333,6.63111111 1.29777778,6.54222222 C1.58222222,6.45333333 1.72444444,
				6.11555556 1.61777778,5.84888889 Z" />
			<path d="M15.0755556,0.568888889 C14.9511111,0.302222222 14.6311111,0.195555556
				14.3644444,0.337777778 C14.0977778,0.462222222 13.9911111,0.782222222 14.1333333,
				1.04888889 C14.88,2.54222222 14.9688889,4.28444444 14.3822222,5.84888889
				C14.2755556,6.11555556 14.4177778,6.43555556 14.6844444,6.54222222 C14.9511111,
				6.64888889 15.2711111,6.50666667 15.3777778,6.24 C16.0711111,4.37333333 15.9644444,
				2.32888889 15.0755556,0.568888889 Z" />
			<path d="M2.80888889,5.15555556 C3.09333333,5.10222222 3.27111111,4.83555556 3.21777778,
				4.55111111 C3.11111111,3.92888889 3.12888889,3.30666667 3.27111111,2.70222222
				C3.34222222,2.41777778 3.16444444,2.13333333 2.88,2.06222222 C2.59555556,1.99111111
				2.31111111,2.16888889 2.24,2.45333333 C2.06222222,3.2 2.04444444,3.98222222
				2.16888889, 4.74666667 C2.22222222,5.03111111 2.50666667,5.20888889 2.80888889,
				5.15555556 Z" />
			<path d="M12.7288889,2.68444444 C12.8711111,3.28888889 12.8888889,3.92888889 12.7822222,
				4.53333333 C12.7288889,4.81777778 12.9244444,5.10222222 13.2088889,5.15555556
				C13.4933333, 5.20888889 13.7777778,5.01333333 13.8311111,4.72888889 C13.9733333,
				3.96444444 13.9555556,3.18222222 13.7777778,2.43555556 C13.7244444,2.15111111 13.44,
				1.95555556 13.1555556,2.00888889 C12.8711111,2.06222222 12.6755556,2.34666667
				12.7288889,2.63111111 C12.7288889,2.64888889 12.7288889,2.66666667 12.7288889,
				2.68444444 Z" />
			<path d="M11.6088889,6.96888889 C11.0755556,6.4 10.8444444,5.81333333 10.8444444,
				5.08444444 L10.8444444,4.26666667 C10.8444444,3.25333333 10.2933333,2.32888889
				9.42222222,1.83111111 L9.42222222,1.49333333 C9.42222222,0.728888889 8.8,
				0.106666667 8.03555556,0.106666667 C7.27111111,0.106666667 6.64888889,0.728888889
				6.64888889,1.49333333 L6.64888889,1.84888889 C5.76,2.36444444 5.22666667,3.32444444
				5.22666667,4.35555556 L5.22666667,5.08444444 C5.22666667,5.81333333 4.99555556,6.4
				4.46222222,6.96888889 C3.87555556,7.00444444 3.41333333,7.48444444 3.41333333,
				8.08888889 L3.41333333,8.37333333 C3.41333333,8.99555556 3.91111111,9.49333333
				4.53333333,9.49333333 L6.45333333,9.49333333 C6.56,10.3822222 7.34222222,11.0044444
				8.23111111,10.9155556 C8.97777778,10.8266667 9.56444444,10.24 9.65333333,
				9.49333333 L11.5555556,9.49333333 C12.1777778,9.49333333 12.6755556,8.99555556
				12.6755556,8.37333333 L12.6755556,8.08888889 C12.6577778,7.48444444 12.1955556,
				7.00444444 11.6088889,6.96888889 Z" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Bell.js